import React from "react";
import { Error, LoaderError } from "@dpdgroupuk/mydpd-ui";

const NotFound = () => {
  const error = new LoaderError({
    statusCode: 404
  });
  return /*#__PURE__*/React.createElement(Error, error);
};

export default NotFound;